<script>
export default {
  name: 'Stats',
  props: {
    minWidth: {
      type: String,
      default: '200px'
    },
    maxWidth: {
      type: String,
      default: '1fr'
    }
  },
  functional: true,
  render(h, {children, props, $style}) {
    const {minWidth, maxWidth} = props
    let style
    if (minWidth || maxWidth) {
      style = {
        gridTemplateColumns: `repeat(
          auto-fill,
          minmax(
            ${minWidth || '200px'},
            ${maxWidth || '1fr'}
          )
        )`
      }
    }
    return h('div', {
      class: [
        'UIElement',
        $style.Stats
      ],
      style
    }, children)
  }
}
</script>

<style lang="scss" module>
.Stats {
  display: grid;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}
</style>
